module.exports = __webpack_public_path__ + "img/ic_my_devices_white.061ba892.svg";